import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useUser } from './Context/UserContext';
import profileImg from '../assets/logo.png';
import Mindteck from '../assets/Mindteck Logo.png';
import UserInfoCard from '../../src/components/UserInfoCard';
import '../styles/NavMenu.css';

// Routes that provide their own header/shell — the global top bar is hidden here.
const HIDE_NAV_ON = ['/', '/login', '/sign-up', '/forgot-password', '/master-page', '/sso'];

function NavMenu() {
    const { user } = useUser();
    const [showCard, setShowCard] = useState(false);
    const location = useLocation();
    const handleImageClick = () => setShowCard(!showCard);
    const isActive = (path) => location.pathname.toLowerCase() === path.toLowerCase();

    const hidden = HIDE_NAV_ON.includes(location.pathname.toLowerCase());

    // Only offset the page body when the fixed bar is actually rendered.
    useEffect(() => {
        document.body.classList.toggle('has-global-nav', !hidden && !user);
        return () => document.body.classList.remove('has-global-nav');
    }, [hidden, user]);

    if (hidden || user) {
        return null;
    }

    return (
        <header>
            <nav className="navbar app-nav">
                <div className="nav-inner">
                    {/* Brand */}
                    <Link to="/" className="nav-brand" aria-label="Mindteck home">
                        <img src={Mindteck} className="mindteck-img" alt="Mindteck" />
                    </Link>

                    {/* Links */}
                    <div className="nav-links">
                        <Link to="/" className={`nav-link${isActive('/') ? ' active' : ''}`}>
                            Home
                        </Link>
                        {!user ? (
                            <>
                                <Link to="/login" className={`nav-link${isActive('/login') ? ' active' : ''}`}>
                                    Login
                                </Link>
                                <Link to="/sign-up" className={`nav-link${isActive('/sign-up') ? ' active' : ''}`}>
                                    Sign Up
                                </Link>
                            </>
                        ) : (
                            <>
                                <Link to="/master-page" className={`nav-link${isActive('/master-page') ? ' active' : ''}`}>
                                    Dashboard
                                </Link>
                                <img
                                    src={profileImg}
                                    className="profile-img"
                                    onClick={handleImageClick}
                                    alt="User"
                                />
                                {showCard && <UserInfoCard user={user} onClose={() => setShowCard(false)} />}
                            </>
                        )}
                    </div>
                </div>
            </nav>
        </header>
    );
}

export default NavMenu;
